import React, { useEffect, useRef } from 'react';
import './ScrapingLogs.css';

function ScrapingLogs({ logs, isActive }) {
  const logsEndRef = useRef(null);

  // Auto-scroll to bottom when new logs are added
  useEffect(() => {
    if (logsEndRef.current) {
      logsEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs]);

  if (!isActive && logs.length === 0) {
    return null;
  }

  return (
    <div className="scraping-logs-container">
      <div className="logs-header">
        <h3>Scraping Activity Logs</h3>
        {isActive && <span className="loading-indicator">●</span>}
      </div>
      <div className="logs-content">
        {logs.length === 0 ? (
          <div className="no-logs">No logs yet. Start a scrape to see activity.</div>
        ) : (
          logs.map((log, index) => (
            <div 
              key={index} 
              className={`log-entry ${log.type || 'info'}`}
            >
              <span className="log-timestamp">[{log.timestamp}]</span>
              <span className="log-message">{log.message}</span>
            </div>
          ))
        )}
        <div ref={logsEndRef} />
      </div>
    </div>
  );
}

export default ScrapingLogs;


